import { render, staticRenderFns } from "./EditOrderingHours.vue?vue&type=template&id=b7d4872a&"
import script from "./EditOrderingHours.vue?vue&type=script&lang=ts&"
export * from "./EditOrderingHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports